(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mo-erga-materials"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var pbtn = e.target.closest('[data-mo-mat-print]');
    if (pbtn) { window.print(); return; }
    var btn = e.target.closest('[data-mo-mat-add]');
    if (!btn || btn.disabled) return;
    var id = btn.getAttribute('data-variant');
    if (!id) return;
    /* Miktar bloktan gelir (qty). Bir isin gercekten kac kutu istedigini
       sayfa soyluyorsa sepete de o kadar girmeli. Varsayilan 1. */
    var qty = parseInt(btn.getAttribute('data-qty'), 10);
    if (!qty || qty < 1) qty = 1;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    }).then(function () {
      btn.textContent = 'Προστέθηκε ✓';
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('mo:cart:added'));
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-mo-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
    }).catch(function () {
      btn.textContent = 'Σφάλμα — ξανά';
    }).finally(function () {
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = orig;
        btn.classList.remove('is-added');
      }, 2400);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
